import React from "react";
const PropertySizeSelect = (props) => {
  //render the property size dropdown;
  const propertySizeList = ["1 BHK", "2 BHK", "3 BHK", "3 + BHK", "FEW ITEMS"];

  const selectedPropertySize = props.defaultValue;
  const JSX = (
    <select
      className={props.className}
      name={props.name}
      defaultValue={selectedPropertySize}
      ref={props.innerRef}
    >
      {propertySizeList.map((value, index) => {
        return (
          <option key={index} value={value}>
            {value}
          </option>
        );
      })}
    </select>
  );
  return JSX;
};

export default PropertySizeSelect;
